import { Route, Routes, Navigate } from "react-router-dom";

import useAuth from "hooks/use-auth";

import Login from "pages/Login";
import AboutUs from "pages/aboutus";
import ContactUs from "pages/contactUs";
import Blogs from "pages/blogs";
import BlogTags from "pages/blogs/tags";
import Advice from "pages/advice";
import AddNewBlog from "pages/blogs/add";
import EditBlog from "pages/blogs/edit";
import VideosPage from "pages/videos";
import MetaTags from "pages/metaTags";
import AdvListPage from "pages/adv";
import AddNewAdv from "pages/adv/add";
import IndexHeader from "pages/header";
import EditAdv from "pages/adv/edit";

export default function RoutesCM() {
  const AuthCTX = useAuth();

  if (!AuthCTX.isLoggedIn) {
    return (
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    );
  }
  return (
    <Routes>
      <Route path="/about_us" element={<AboutUs />} />
      <Route path="/contact_us" element={<ContactUs />} />
      <Route path="/advice" element={<Advice />} />
      <Route path="/blogs" element={<Blogs />} />
      <Route path="/blog/:id/tags" element={<BlogTags />} />
      <Route path="/blog/add" element={<AddNewBlog />} />
      <Route path="/blog/edit/:id" element={<EditBlog />} />
      <Route path="/videos" element={<VideosPage />} />
      <Route path="/meta_tags" element={<MetaTags />} />
      <Route path="/adv" element={<AdvListPage />} />
      <Route path="/adv/add" element={<AddNewAdv />} />
      <Route path="/adv/edit/:id" element={<EditAdv />} />
      <Route path="/header" element={<IndexHeader />} />

      <Route path="*" element={<Navigate to="/adv" />} />
    </Routes>
  );
}
